/**
 * Account page module
 *
 * @module views/pages/account-page
 */
define('views/pages/account-main',['require','jquery','underscore','views/base/page','views/base/view','views/base/collection','models/base/collection','models/base/modal','views/base/modal','lib/utils','helpers/application','models/modals/claim/index','views/modals/claim/index','text!templates/pages/account-main/index.ejs','text!templates/pages/account-main/table.ejs','text!templates/pages/account-main/table-row.ejs','text!templates/pages/account-main/saldo.ejs','text!templates/pages/account-main/navbar.ejs','text!templates/pages/account-main/file.ejs','text!templates/pages/account-main/file-list.ejs','datepicker'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        PageView = require('views/base/page'),
        View = require('views/base/view'),
        CollectionView = require('views/base/collection'),
        Collection = require('models/base/collection'),
        Modal = require('models/base/modal'),
        ModalView = require('views/base/modal'),
        utils = require('lib/utils'),
        applicationHelper = require('helpers/application'),
        ClaimModalModel = require('models/modals/claim/index'),
        ClaimModalView = require('views/modals/claim/index'),
        template = require('text!templates/pages/account-main/index.ejs'),
        templateTable = require('text!templates/pages/account-main/table.ejs'),
        templateTableRow = require('text!templates/pages/account-main/table-row.ejs'),
        templateSaldo = require('text!templates/pages/account-main/saldo.ejs'),
        templateNavbar = require('text!templates/pages/account-main/navbar.ejs'),
        templateFile = require('text!templates/pages/account-main/file.ejs'),
        templateFileList = require('text!templates/pages/account-main/file-list.ejs');

    require('datepicker');

    var FilesModal = Modal.extend({
        urlPath: '/files',
        constructor: function(data) {
            this.files = new Collection(data ? data.files : [], { parse: true });
            Modal.apply(this, arguments);
        },
        parse: function(data) {
            this.files.reset(data.files);
            return data;
        },
        urlParams: function() {
            var params = Modal.prototype.urlParams.apply(this, arguments);

            params.type = this.get('ownerType');
            params.id = this.get('ownerId');
            return params;
        }
    });

    var FileView = View.extend({
        tagName: 'tr',
        template: templateFile
    });

    var FileListView = CollectionView.extend({
        itemView: FileView,
        listSelector: 'tbody',
        fallBackSelector: '.hidden',
        tagName: 'table',
        className: 'table table-bordered table-hover',
        template: templateFileList
    });

    var AccountRowView = View.extend({
        template: templateTableRow,
        className: 'account-table-row',
        tagName: 'tr',
        listen: {
            'change:selected model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            this.delegate('click', '.icon-file', this.clickFile);
            this.delegate('click', '.icon-comment', this.clickComment);
            this.delegate('click', this.clickRow);
            if (this.model.get('ClaimNumber')) {
                this.delegate('click', '.account-article a', this.clickClaim);
            }

        },
        clickRow: function() {
            var item = this.model.collection.findWhere({ selected: true });
            if (item && item !== this.model) {
                item.set('selected', false);
            }
            this.model.set('selected', true);

            if (this.doShowComment) {
                utils.popover(this.$('.icon-comment'), 'Комментарий', this.model.get('Comment'));
                this.doShowComment = false;
            }

        },
        clickClaim: function() {
            var modalModel = new ClaimModalModel({});
            modalModel.on('action', function() {
            });

            this.subview('card', new ClaimModalView({ model: modalModel }));

            modalModel.content.set('claimId', this.model.get('ID_Claim'));
            modalModel.content.load();
        },
        clickComment: function() {
            this.doShowComment = true;
        },
        clickFile: function(ev) {
            ev.stopPropagation();
            ev.preventDefault();

            var modalModel = new FilesModal({
                'title': 'Файлы',
                'buttons': [
                    { caption: 'Закрыть', className: '', 'action': 'cancel' }
                ],
                'ownerType': $(ev.target).data('type'),
                'ownerId': $(ev.target).data('id')
            });
            var modalView = new ModalView({ model: modalModel });
            var fileListView = new FileListView({ collection: modalModel.files, region: 'modal-content' });

            modalView.subview('filelist', fileListView);

            modalModel.fetch().complete(function() {

            });

            modalModel.on('action', function(action, cancel) {
                if (action === 'submit') {
                    cancel();
                }
            });

            return 0;
        },
        render: function() {
            this.$('.icon-comment').popover('destroy');
            View.prototype.render.apply(this, arguments);
            if (this.model.get('selected')) {
                this.$el.addClass('active');
            } else {
                this.$el.removeClass('active');
            }

            console.log('render', this.model.getAttributes());
        },
        dispose: function() {
            if (this.disposed) {
                return;
            }

            this.$('.icon-comment').popover('destroy');

            View.prototype.dispose.apply(this, arguments);
        }
    });

    var AccountTableView = CollectionView.extend({
        autoRender: true,
        className: 'account-table',
        itemView: AccountRowView,
        region: 'account-main-table',
        animationDuration: 0,
        template: templateTable,
        listSelector: 'tbody',
        loadingSelector: '.loading',
        fallbackSelector: '.empty',
        listen: {
            'resize model': 'onResize',
            'addedToDOM': 'onResize'
        },
        initialize: function() {
            CollectionView.prototype.initialize.apply(this, arguments);
        },
        render: function() {
            CollectionView.prototype.render.apply(this, arguments);

            this.$('tbody').off('scroll').on('scroll', _.bind(function() { this.$('.icon-comment').popover('destroy'); }, this));
        },
        onResize: function() {
            var h = $('body').height();
            var $b = this.$('tbody');
            $b.css('height', h - $b.offset().top - 12);
        }
    });

    var AccountSaldoView = View.extend({
        region: 'account-main-saldo',
        autoRender: true,
        template: templateSaldo,
        tagName: 'div',
        className: 'alert'
    });

    var AccountNavbarView = View.extend({
        region: 'account-main-navbar',
        className: 'navbar-inner',
        autoRender: true,
        template: templateNavbar,
        listen: {
            'change:fromDate model': 'fromDateChange',
            'change:toDate model': 'toDateChange'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            this.delegate('click', '#loadData', this.loadData);
        },
        render: function() {
            View.prototype.render.apply(this, arguments);

            var _this = this;

            var $fd = this.$('#fromDate');
            var $td = this.$('#toDate');

            var fromDate = this.fromDate = $fd
                .datepicker({
                    format: 'dd.mm.yyyy',
                    weekStart: 1
                })
                .on('changeDate', function(ev) {
                    fromDate.hide();
                    _this.model.set('fromDate', ev.date);
                })
                .on('show', function() {
                    if (_this.model.get('loading')) {
                        fromDate.hide();
                    }
                })
                .data('datepicker');
            fromDate.setValue(this.model.get('fromDate'));

            var toDate = this.toDate = $td
                .datepicker({
                    format: 'dd.mm.yyyy',
                    weekStart: 1
                })
                .on('changeDate', function(ev) {
                    toDate.hide();
                    _this.model.set('toDate', ev.date);
                })
                .on('show', function() {
                    if (_this.model.get('loading')) {
                        toDate.hide();
                    }
                })
                .data('datepicker');
            toDate.setValue(this.model.get('toDate'));
        },
        dispose: function() {
            if (this.disposed) { return; }

            if (this.fromDate) {
                this.fromDate.picker.remove();
            }

            if (this.toDate) {
                this.toDate.picker.remove();
            }

            View.prototype.dispose.apply(this, arguments);
        },
        loadData: function() {
            applicationHelper.redirectTo('account#main', {
                fromDate: utils.fmtDate(this.model.get('fromDate')),
                toDate: utils.fmtDate(this.model.get('toDate'))
            });
        },
        fromDateChange: function(model, date) {
            if (date.valueOf() > model.get('toDate').valueOf()) {
                var newDate = new Date(date);
                newDate.setDate(newDate.getDate() + 1);
                model.set('toDate', newDate);
            }

            if (this.fromDate) {
                this.fromDate.setValue(date);
            }
        },
        toDateChange: function(model, date) {
            if (date.valueOf() < model.get('fromDate').valueOf()) {
                var newDate = new Date(date);
                newDate.setDate(newDate.getDate() - 1);
                model.set('fromDate', newDate);
            }

            if (this.toDate) {
                this.toDate.setValue(date);
            }
        }
    });

    var AccountMainPageView = PageView.extend({
        id: 'pages-account-main-page',
        autoRender: true,
        template: template,
        windowResize: true,
        regions: {
            'account-main-table': '#table-container',
            'account-main-saldo': '#saldo-container',
            'account-main-navbar': '#account-main-navbar'
        },
        listen: {
            'change:loading model': 'render'
        },
        initialize: function() {
            PageView.prototype.initialize.apply(this, arguments);
        },
        render: function() {
            PageView.prototype.render.apply(this, arguments);

            this.subview('saldo', new AccountSaldoView({ model: this.model }));
            this.subview('navbar', new AccountNavbarView({ model: this.model }));
            this.subview('table', new AccountTableView({ collection: this.model.items, model: this.model }));
        },
        updateURL: function() {
            utils.changeURL('account#main', {
                fromDate: utils.fmtDate(this.model.get('fromDate')),
                toDate: utils.fmtDate(this.model.get('toDate'))
            });
        }
    });

    return AccountMainPageView;
});
